import { render, staticRenderFns } from "./MoreDropdown.vue?vue&type=template&id=20c00c72&scoped=true"
import script from "./MoreDropdown.vue?vue&type=script&lang=ts"
export * from "./MoreDropdown.vue?vue&type=script&lang=ts"
import style0 from "./MoreDropdown.vue?vue&type=style&index=0&id=20c00c72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c00c72",
  null
  
)

export default component.exports